<template>
  <div class="row col-wrapper">
    <!-- TODO: Move all necessary modal to separate file -->
    <leftNavigation v-on:openFile="openFile" v-on:selectEmail="emailSelected"></leftNavigation>

    <!-- Remove middle pane for Exam -->
    <template v-if="versionTemplateKey == 2">
      <mailView
        className="col-lg-9 col-md-8 modex"
        :currentEmail="currentEmail"
        v-on:openFile="openFile"
      ></mailView>
    </template>

    <template v-else>
      <inbox v-on:selectEmail="emailSelected"></inbox>
      <mailView
        className="mail-view p-15"
        :currentEmail="currentEmail"
        v-on:openFile="openFile"
      ></mailView>
    </template>

    <notification
      v-if="unreadMessages > 0"
      :message="newMessageText"
      :isLoading="false"
      :isWarning="false"
      :isActive.sync="showAlert"
    >
      <span slot="icon" class="glyphicon glyphicon-comment"></span>
    </notification>

    <modal :show-okay="false" id="myModal" size="lg" closeClass="btn-danger-outline">
      <template v-if="openedFile">
        <h4 slot="title">
          {{ openedFile.displayName }}
          <a class="btn btn-sm btn-primary mat" :href="fileHref" target="_blank">Open in window</a>
        </h4>

        <iframe
          v-if="/\.xls|\.xlsx|\.doc|\.docx|\.ppt|\.pptx/.test(fileHref.toLowerCase())"
          id="office-iframe"
          slot="body"
          width="100%"
          height="800px"
          frameborder="0"
          @load="load"
          :src="fileSrcGoogle"
          :key="fileSrcGoogle"
          :title="openedFile.displayName"
        ></iframe>
        <template v-else-if="/\.pdf/.test(fileHref.toLowerCase())">
          <object
            :data="fileHref"
            type="application/pdf"
            slot="body"
            width="100%"
            height="800px"
            :key="fileHref"
            frameborder="0"
          >
            <iframe
              slot="body"
              width="100%"
              height="800px"
              frameborder="0"
              :src="fileSrcGoogle"
              :key="fileSrcGoogle"
              :title="openedFile.displayName"
            ></iframe>
          </object>
        </template>
        <template v-else-if="/\.csv/.test(fileHref.toLowerCase())">
          <iframe
            slot="body"
            width="100%"
            height="800px"
            frameborder="0"
            :src="fileSrcGoogle"
            :key="fileSrcGoogle"
            :title="openedFile.displayName"
          ></iframe>
        </template>
        <template v-else-if="/\.jpg|\.png|\.jpeg/.test(fileHref.toLowerCase())">
          <img
            slot="body"
            :src="fileHref"
            :alt="
              openedFile.altText != null && openedFile.altText.length > 0
                ? openedFile.altText
                : openedFile.displayName
            "
            class="attachment-image"
          />
        </template>

        <div v-if="openedFile.FK_fileTypeKey === 2" slot="body">
          <div class="embed-responsive embed-responsive-16by9">
            <video ref="video" controls>
              <source :src="fileHref" type="video/mp4" />
              <track
                v-if="openedFile.videoSubtitles != null && openedFile.videoSubtitles.length > 0"
                :src="`/capsiminbox/resources/vtt/${openedFile.videoSubtitles}`"
                default
                kind="subtitles"
                srclang="en"
                label="English"
              />
            </video>
          </div>
          <br />
          <a
            v-if="openedFile.audioDescription != null && openedFile.audioDescription.length > 0"
            class="mt-5"
            target="_blank"
            :href="`${openedFile.audioDescription}`"
            >View Video with Audio Description</a
          >
          <!-- <iframe class="embed-responsive-item" :src="fileHref">
                      <track src="/capsiminbox/resources/vtt/CapsimInbox_IDP_Video.vtt" default kind="subtitles" srclang="en" label="English">
                    </iframe> -->
        </div>
      </template>
    </modal>

    <!-- I see a pattern in the these modal formats, i think these could be combined into a single modal that loads in the info details.  -->
    <!-- However, that would require a code rewrite, and could result in an inbox issue.  -->

    <template v-if="$store.state.assessmentTypeKey == constants.ASSESSMENT_TYPE_KEY.DEMO">
      <modal
        :confirm-text="'Exit'"
        v-on:confirm="exitInbox"
        id="assessment-warning"
        closeClass="btn-danger"
      >
        <h4 slot="title">
          {{
            versionConfig.exitModal ? versionConfig.exitModal.heading : 'Assessment Not Complete'
          }}
        </h4>
        <p v-if="versionConfig.exitModal" slot="body" v-html="versionConfig.exitModal.body"></p>
        <p v-else slot="body">
          <strong>WARNING:</strong> Your assessment is currently in-progress. If you choose to
          leave, the assessment will be marked as complete and you cannot re-enter.
        </p>
      </modal>

      <modal
        :confirm-text="'Complete'"
        v-on:confirm="exitInbox"
        :show-close="false"
        id="assessment-complete"
      >
        <template v-if="versionConfig.completeModal">
          <h4 slot="title">
            {{
              versionConfig.completeModal.heading
                ? versionConfig.completeModal.heading
                : 'Assessment Complete'
            }}
          </h4>
          <p
            v-if="versionConfig.completeModal"
            slot="body"
            v-html="
              versionConfig.completeModal.body
                ? versionConfig.completeModal.body
                : versionTemplateKey == 3
                ? 'You have completed your CapsimInbox-XM assessment. If results have been released, you will be able to access them from the dashboard.'
                : 'You have completed the CapsimInbox assessment. When your instructor has released results, you can view these on the dashboard.'
            "
          ></p>
        </template>
        <template v-else>
          <h4 slot="title">Assessment Complete</h4>
          <p slot="body">
            You have completed the CapsimInbox assessment. When your instructor has released
            results, you can view these on the dashboard.
          </p>
        </template>
      </modal>
    </template>

    <template v-else-if="$store.state.assessmentTypeKey == constants.ASSESSMENT_TYPE_KEY.PREVIEW">
      <modal
        v-on:closed="hideEntryModal"
        :confirm-text="'Continue'"
        v-on:confirm="hideEntryModal"
        :showClose="false"
        id="preview-entry-modal"
      >
        <h4 slot="title">Preview Experience</h4>
        <p slot="body">
          You are now previewing the Inbox experience as a participant would see it. In this mode,
          you are able to play around through the scenarios you have designed and decisions will not
          be stored or tracked. If you would like to restart the preview experience, refresh the
          page or click the preview link from the builder <br /><br /><b
            >When you are ready to return to the builder, navigate to the previous tab</b
          >
        </p>
      </modal>
    </template>

    <template v-else-if="$store.state.assessmentTypeKey == constants.ASSESSMENT_TYPE_KEY.REHEARSAL">
      <modal
        v-on:closed="hideModal"
        :confirm-text="'Next'"
        v-on:confirm="hideModal"
        :showClose="false"
        id="step-1"
      >
        <h4 slot="title">{{ info.assessmentRehearsal.title }}</h4>
        <p slot="body">{{ info.assessmentRehearsal.body }}</p>
      </modal>

      <template v-if="versionTemplateKey == 2">
        <modal
          :confirm-text="'Complete'"
          v-on:confirm="exitTutorials()"
          :show-close="false"
          confirm-class="btn-success"
          id="assessment-complete"
        >
          <h4 slot="title">Tutorial Complete</h4>
          <p slot="body">
            You've completed all questions in this tutorial. If you'd like to view this again,
            please re-select "Tutorial" in your left hand navigation.
            <br /><br />
            Please note: The report links to the left are only for this tutorial. Your exam will use
            different data.
          </p>
        </modal>

        <modal
          :confirm-text="'OK'"
          v-on:confirm="closeModal"
          :show-close="false"
          id="assessment-warning"
        >
          <h4 slot="title">Warning</h4>
          <p slot="body">
            You have not completed all of the questions in this tutorial. If you feel prepared, feel
            free to enter your exam or retake this one!
          </p>
        </modal>
      </template>
    </template>

    <template v-else>
      <template v-if="versionConfig.allowReEntryInbox || allowInboxSimReEntry">
        <welcome-back-modal :role="role" @exit="exitWelcomebackModal" />

        <!-- overwrite this information to assesment-warning-modal for upcoming sprint -->
        <modal
          :confirm-text="info.assessmentWarning.confirmText"
          :close-text="info.assessmentWarning.closeText"
          :show-close="info.assessmentWarning.showClose"
          :show-okay="!hideExitButton"
          :show-confirm-as-link="true"
          close-class="btn-primary"
          confirm-class="pull-left link mt-5"
          v-on:confirm="openSubmitModal"
          @closed="exitToDashboard"
          :close-modal-upon-click="false"
          id="assessment-warning"
        >
          <h1 slot="title">{{ info.exit }}</h1>
          <p slot="body" v-html="info.assessmentWarning.body"></p>
        </modal>

        <assessment-submit-modal @confirm="exitInbox(info.assessmentWarning.exit)" />
      </template>
      <template v-else>
        <template v-if="versionTemplateKey == 2">
          <modal
            :confirm-text="info.assessmentWarning.confirmText"
            :close-text="info.assessmentWarning.closeText"
            :show-close="info.assessmentWarning.showClose"
            :show-okay="!hideExitButton"
            :show-confirm-as-link="false"
            close-class="btn-primary"
            confirm-class="btn btn-default pull-left"
            v-on:confirm="exitInbox(info.assessmentComplete.exit)"
            @closed="closeModal"
            :close-modal-upon-click="false"
            id="assessment-warning"
          >
            <h1 slot="title">Exam Not Complete</h1>
            <p slot="body" v-html="info.assessmentWarning.body"></p>
          </modal>
        </template>
        <template v-else>
          <assessment-warning-modal @confirm="exitInbox" />
        </template>
      </template>

      <modal
        :confirm-text="info.assessmentComplete.confirmText"
        :close-text="info.assessmentComplete.closeText"
        :show-close="info.assessmentComplete.showClose"
        :show-okay="!hideExitButton"
        close-class="btn-default pull-left"
        confirm-class="btn-primary"
        v-on:confirm="exitInbox(info.assessmentComplete.exit)"
        id="assessment-complete-inbox"
      >
        <h1 slot="title">{{ info.type }} Complete</h1>
        <p slot="body">{{ info.assessmentComplete.body }}</p>
      </modal>

      <modal
        :showExit="false"
        :show-okay="hideExitButton"
        :close-text="'Close'"
        close-class="btn-default pull-right"
        confirmClass="btn-danger"
        id="past-due-modal-inbox"
      >
        <h1 slot="title">Timer Expired</h1>
        <p slot="body">
          The timer has expired. Please respond to any unanswered messages and submit your Inbox.
        </p>
      </modal>

      <modal
        :showExit="false"
        :show-close="false"
        :confirm-text="'Close'"
        @confirm="exitInbox(true)"
        confirm-class="btn-default pull-right"
        id="past-due-modal-inbox-enforced"
      >
        <h1 slot="title">Timer Expired</h1>
        <p slot="body">Please click the button below and return to the dashboard.</p>
      </modal>

      <modal
        :showExit="false"
        :show-close="false"
        :show-okay="!hideExitButton"
        :confirm-text="'Close'"
        confirmClass="btn-danger"
        v-on:confirm="exitInbox(`previouslycompleted`)"
        id="already-complete-modal-inbox"
      >
        <h1 slot="title">Assessment has ended</h1>
        <p slot="body">
          You have already completed the assessment and your responses have been submitted.
        </p>
      </modal>

      <template v-if="versionTemplateKey == 2">
        <modal
          :confirm-text="info.assessmentConfirmation.confirmText"
          :close-text="info.assessmentConfirmation.closeText"
          close-class="btn-default pull-left"
          confirm-class="btn-primary"
          v-on:confirm="exitInbox(info.assessmentConfirmation.exit)"
          id="assessment-confirmation"
        >
          <h4 slot="title">{{ info.type }} Confirmation</h4>
          <p slot="body">{{ info.assessmentConfirmation.body }}</p>
        </modal>

        <modal
          :showExit="false"
          :show-close="false"
          :confirm-text="'Close Exam'"
          confirm-class="btn-primary"
          v-on:confirm="exitInbox(true)"
          id="past-due-modal"
        >
          <h4 slot="title">Exam has ended</h4>
          <p slot="body">Time has expired. Your results have been submitted.</p>
        </modal>

        <error-response-modal :errors="errors"></error-response-modal>

        <modal
          :showOkay="false"
          :showExit="false"
          :close-text="'Start The Test'"
          v-on:closed="showTermsOfUseModal()"
          id="entry-custom-modal"
          close-class="btn-primary"
        >
          <template v-if="versionConfig">
            <h2 slot="title" v-html="versionConfig.customModalTitle"></h2>
            <p class="modal-body-text" slot="body" v-html="versionConfig.customModalBody"></p>
          </template>
        </modal>

        <modal
          :showOkay="false"
          :showExit="false"
          :close-text="'Agree'"
          v-on:closed="showInfoModal()"
          id="terms-of-use-modal"
          close-class="btn-primary"
        >
          <h2 slot="title">Terms Of Use</h2>
          <p class="modal-body-text" slot="body">
            This exam is licensed exclusively for single use to {{ username }}; reuse or use by
            anyone else is fraudulent. This is an individual and confidential examination, protected
            by the laws of the United States and international law. <br /><br />
            <b> Exam agreement: </b> <br />By pressing the Agree button below I certify that I am
            {{ username }}. I agree I will not record or copy any exam question or answer in any
            form, verbally, in writing, or by electronic means, including but not limited to
            screenshots, recorded media, telephony, and Internet web sites, blogs, chat rooms,
            e-mail, or forums.
          </p>
        </modal>

        <modal
          :showOkay="false"
          :showExit="false"
          :close-text="'Continue'"
          v-on:closed="startClock()"
          id="info-modal"
          close-class="btn-primary"
        >
          <p class="modal-body-text" slot="body">
            As you complete your exam, you will need to reference certain reports, graphs, and
            charts. These are housed in your left hand navigation under the <b>Files</b> header.
          </p>
        </modal>
      </template>
    </template>
  </div>
</template>

<script>
  import Inbox from './Inbox.vue';
  import MailView from '@assessment/MailView';
  import LeftNavigation from './LeftNavigation.vue';
  import Modal from '../../shared_components/Modal.vue';
  import CapsimTable from '../../shared_components/CapsimTable.vue';
  import notification from '../../shared_components/Notification.vue';
  import { mapGetters, mapState } from 'vuex';
  import debounce from 'lodash/debounce';
  import delay from 'lodash/delay';
  import ErrorResponseModal from './ErrorResponseModal';
  import { onUnload } from '../../utils/windowEvent';
  import WelcomeBackModal from './Modals/WelcomeBackModal.vue';
  import AssessmentWarningModal from './Modals/AssessmentWarningModal.vue';
  import AssessmentSubmitModal from './Modals/AssessmentSubmitModal.vue';
  import { logUserAction } from '../api/log';
  export default {
    name: 'Home',

    data() {
      return {
        currentEmail: null,
        openedFile: null,
        showAlert: true,
        hideExitButton: false,
        onLine: navigator.onLine,
        isInboxPastDueModalShown: false,
        isWelcomebackModalClosed: false,
        isIframeLoaded: false,
      };
    },

    beforeRouteEnter(to, from, next) {
      next((instance) => {
        instance.$store
          .dispatch('LOAD_STATE')
          .then(() => {
            if (
              instance.$store.state.assessmentTypeKey ==
              instance.$store.getters.constants.ASSESSMENT_TYPE_KEY.WEBAPP
            ) {
              if (
                instance.$store.state.versionTemplateKey != 2 &&
                !instance.$store.state.studentReEntered
              )
                return instance.$store
                  .dispatch('START_SIM')
                  .then(() => instance.$store.dispatch('SET_PHASE_DEPENDANT_QUESTIONS'));
            }
          })
          .then(() => {
            if (
              instance.$store.state.versionTemplateKey != 2 ||
              instance.$store.state.assessmentTypeKey ==
                instance.$store.getters.constants.ASSESSMENT_TYPE_KEY.REHEARSAL
            ) {
              return instance.$store.dispatch('time/initializeClock');
            }
          })
          .catch((err) => console.log(err));
      });
    },

    mounted() {
      // if student enters the site for the first time, add event listener to record when student exit the inbox assessment with below user events
      if (!this.$store.state.studentReEntered) {
        window.addEventListener(
          'pagehide',
          onUnload.bind(
            null,
            { actionKey: JSON.stringify(14) },
            '/capsiminbox/webapp/log-activity',
            this.$store.state.assessmentTypeKey,
            true
          )
        );
        window.addEventListener(
          'unload',
          onUnload.bind(
            null,
            { actionKey: JSON.stringify(14) },
            '/capsiminbox/webapp/log-activity',
            this.$store.state.assessmentTypeKey,
            true
          )
        );
      }

      EventBus.$on('completeAssessment', (value) => this.completeAssessment(value));
      this.$el.style.height = `${window.innerHeight - 50}px`;
      window.addEventListener(
        'resize',
        () => (this.$el.style.height = `${window.innerHeight - 50}px`)
      );
      if (this.versionTemplateKey == 2) {
        delay(() => {
          if (this.versionConfig && this.versionConfig.customModalIsDisplay == true)
            $('#entry-custom-modal').modal({ backdrop: 'static', keyboard: false });
          else $('#terms-of-use-modal').modal({ backdrop: 'static', keyboard: false });
        }, 1000);

        //MODXM assessment network add event listener for offline
        window.addEventListener('offline', this.updateOnlineStatus);
      }

      if (
        this.$store.state.assessmentTypeKey ==
        this.$store.getters.constants.ASSESSMENT_TYPE_KEY.REHEARSAL
      ) {
        $('#step-1').modal('show');
      }

      if (
        this.$store.state.assessmentTypeKey ==
        this.$store.getters.constants.ASSESSMENT_TYPE_KEY.PREVIEW
      ) {
        $('#preview-entry-modal').modal('show');
      }

      if (this.isReEntrySingle) {
        this.setThreadedEmailsOnReEntry();
      }
      if (this.versionTemplateKey != 2) {
        delay(() => {
          this.checkIfComplete();
        }, 2000);
        delay(() => {
          this.showWelcomeBackModal();
        }, 1000);
      }
    },

    beforeDestroy() {
      window.removeEventListener('offline', this.updateOnlineStatus);
      window.removeEventListener('pagehide', onUnload);
      window.removeEventListener('unload', onUnload);
    },

    components: {
      Inbox,
      MailView,
      LeftNavigation,
      Modal,
      notification,
      CapsimTable,
      ErrorResponseModal,
      WelcomeBackModal,
      AssessmentWarningModal,
      AssessmentSubmitModal,
    },

    watch: {
      assessmentComplete(val) {
        this.getAssessmentCompleted();
      },

      currentTime(val) {
        if (val <= 0) {
          EventBus.$emit('completeAssessment');
        }
      },
    },

    computed: {
      ...mapGetters(['allowInboxSimReEntry', 'assessmentComplete']),
      ...mapGetters('email', [
        'unansweredEmails',
        'answeredEmails',
        'threadEmails',
        'cleanEmails',
        'activeEmails',
      ]),

      ...mapGetters('chat', [
        'activeMessages',
        'messages',
        'deliveredMessages',
        'messagesFromThread',
      ]),

      ...mapGetters('time', ['currentTime', 'elapsed']),
      ...mapState('time', ['timeinterval']),
      ...mapState([
        'versionKey',
        'userData',
        'hasPhases',
        'simsettings',
        'timeToComplete',
        'role',
        'studentReEntered',
        'versionTemplateKey',
      ]),
      ...mapState({
        assessmentPreviouslyCompleted: (state) => state.assessmentComplete,
      }),

      reports() {
        if (this.$store.state.Reports) {
          return this.$store.state.Reports;
        }
      },

      errors() {
        if (this.$store.state.Errors) {
          return this.$store.state.Errors;
        }
      },

      info() {
        if (this.$store.state) {
          // startCase
          return this.$store.state.info;
        }
      },

      username() {
        if (this.$store.state.userData) {
          const user = this.$store.state.userData;
          return `${user.firstname} ${user.lastname}`;
        }
      },

      unreadMessages() {
        if (this.unansweredEmails.length === 0)
          return this.deliveredMessages.filter((message) => !message.isRead).length;
        else
          return this.deliveredMessages.filter(
            (message) => message.timer <= this.elapsed && !message.isRead
          ).length;
      },

      timer() {
        return this.$store.state.time;
      },

      newMessageText() {
        return `You have ${this.unreadMessages} new ${
          this.unreadMessages > 1 ? 'messages' : 'message'
        }.`;
      },

      isReEntry() {
        return this.versionConfig.isReEntry;
      },

      isReEntrySingle() {
        return this.versionConfig.reEntrySingle;
      },

      isPostAssessment() {
        return this.versionConfig.postAssessment;
      },

      showTimerAsClock() {
        return this.versionConfig.showTimerAsClock;
      },

      fileHref() {
        let link = '';
        if (this.openedFile !== null) {
          // if( this.openedFile.FK_fileTypeKey !== 2 && ( /\.xls|\.xlsx|\.doc|\.docx|\.ppt|\.pptx/.test(this.openedFile.fileName) ) ) link = `${this.$store.state.assetsPath}/capsiminbox/${this.fileType}/${this.openedFile.fileName}`
          if (
            this.openedFile.FK_fileTypeKey !== 2 &&
            /\.xls|\.xlsx|\.doc|\.docx|\.ppt|\.csv|\.pptx/.test(this.openedFile.fileName)
          ) {
            link = `https://assets.capsim.com/capsiminbox/${this.fileType}/${this.openedFile.fileName}`;

            setTimeout(() => {
              if (!this.isIframeLoaded) {
                // reload iframe in case it fails to load
                document.getElementById('office-iframe').src += '';
              }
              this.isIframeLoaded = false;
            }, 2000);
          } else if (this.openedFile.FK_fileTypeKey !== 2)
            link = `${this.$store.state.assetsPath}/capsiminbox/${this.fileType}/${this.openedFile.fileName}`;
          else link = this.openedFile.fileName;
        }
        return link;
      },

      fileSrcGoogle() {
        return `https://docs.google.com/gview?url=${this.fileHref}&embedded=true`;
      },

      fileType() {
        let fileTypeFolder = '';
        if (this.openedFile == null) return fileTypeFolder;
        else if (/\.png|\.jpeg|\.jpg/.test(this.openedFile.fileName)) fileTypeFolder = 'images';
        else if (/\.pdf/.test(this.openedFile.fileName)) fileTypeFolder = 'pdfs';
        else fileTypeFolder = 'documents';

        return fileTypeFolder;
      },

      constants() {
        return this.$store.getters.constants;
      },

      versionConfig() {
        return this.$store.state.versionConfig;
      },
    },

    methods: {
      load() {
        this.isIframeLoaded = true;
      },
      exitTutorials() {
        window.onbeforeunload = undefined;
        return (window.parent.location.href = '/capsiminbox/student/dashboard');
      },
      closeModal() {
        $('#assessment-complete').modal('hide');
        $('#assessment-warning').modal('hide');
      },
      hideModal(modalId) {
        $(`#step-1`).modal('hide');
        $('[data-toggle="popover"]').popover('show');
      },

      hideEntryModal(modalId) {
        $(`#preview-entry-modal`).modal('hide');
      },

      startClock() {
        if (this.$store.state.assessmentTypeKey == this.constants.ASSESSMENT_TYPE_KEY.WEBAPP) {
          this.$store
            .dispatch('START_SIM')
            .then(() => this.$store.dispatch('time/initializeClock'));
        } else {
          this.$store.dispatch('time/initializeClock');
        }
      },
      showInfoModal() {
        const isBciq = this.versionKey === 111;
        if (isBciq) {
          this.startClock();
        } else {
          $('#info-modal').modal({ backdrop: 'static', keyboard: false });
        }
      },
      showTermsOfUseModal() {
        $('#terms-of-use-modal').modal({ backdrop: 'static', keyboard: false });
      },
      openFile(file) {
        this.openedFile = file;
        if (this.$store.state.assessmentTypeKey == this.constants.ASSESSMENT_TYPE_KEY.WEBAPP) {
          !this.openedFile.isLogged &&
            this.logActivity({
              payload: { objectKey: file.fileKey, actionKey: 6 },
            });
        }

        this.openedFile.isLogged = true;
      },

      emailSelected(email) {
        this.currentEmail = email;
      },

      logActivity({ payload, callback }) {
        $.post({
          url: '/capsiminbox/webapp/log-activity',
          dataType: 'json',
          data: payload,
        })
          .done((res) => {
            if (typeof callback == 'function') callback();
          })
          .fail((err) => console.log(err));
      },

      completeAssessment(value) {
        if (this.versionTemplateKey == 2) {
          if (
            this.currentTime <= 0 &&
            this.$store.state.assessmentTypeKey == this.constants.ASSESSMENT_TYPE_KEY.WEBAPP
          ) {
            return this.showExamPastDueModal();
          } else {
            $('#assessment-warning').modal('toggle');
            return;
          }
        } else {
          if (this.assessmentComplete) return this.exitInbox();
          else if (this.currentTime <= 0 && this.timeToComplete === 'enforced') {
            clearInterval(this.timeinterval);
            return this.showInboxPastDueEnforcedModal();
          } else if (
            this.currentTime <= 0 &&
            this.timeToComplete === 'recommended' &&
            !this.isInboxPastDueModalShown &&
            !this.versionConfig?.hideTimer
          ) {
            this.isInboxPastDueModalShown = true;
            return this.showInboxPastDueModal();
          } else if (value === 'manualClickToExit') {
            return this.showManualExitModal();
          }
        }
      },

      //this delays the modal check by a half second to make sure the modal doesn't pop up too early as the getter breifly changes
      getAssessmentCompleted: debounce(function () {
        if (this.assessmentComplete) {
          clearInterval(this.timeinterval); // when user is done with the assessment, clear interval so that it doesn't run forever
          $('#assessment-complete-inbox').modal('toggle');
          $('#assessment-complete').modal('toggle');
        }
      }, 500),

      showReport(reportKey) {
        if (this.reports[reportKey]) {
          this.currentReport = this.reports[reportKey];
          this.currentReportUrl = `/capsiminbox/webapp/report-window?report=${reportKey}`;
          $('#report-modal').modal('toggle');
        }
      },

      async exitInbox(exit) {
        clearInterval(this.timeinterval); // when user is exiting assessment, clear interval so that it doesn't run forever
        this.hideExitButton = true;

        if (this.$store.state.assessmentTypeKey == this.constants.ASSESSMENT_TYPE_KEY.WEBAPP) {
          await logUserAction({ actionKey: 14 }); // Exit Inbox
          this.activeEmails.map((email) => {
            if (email.isWrittenResponse == 1 && email.isSent == false) {
              this.$store
                .dispatch('email/ANSWER_EMAIL_WRITTEN', {
                  questionkey: email.questionKey,
                  writtenResponse: '--NO RESPONSE PROVIDED BY STUDENT--',
                })
                .catch((error) => {
                  this.$store.dispatch('Errors/responseError', error);
                });
            }
          });
          if (
            (exit && this.isReEntrySingle && !this.assessmentComplete) ||
            exit == 'previouslycompleted'
          ) {
            window.onbeforeunload = undefined;
            return (window.location.href = '/capsimInbox/webapp/re-entry-single');
          } else if (exit || (exit === undefined && this.versionTemplateKey !== 2)) {
            window.onbeforeunload = undefined;
            return (window.location.href = '/capsiminbox/webapp/complete-assessment');
          } else {
            this.hideExitButton = false;
            $('#assessment-complete').modal('hide');
            $('#assessment-complete-inbox').modal('hide');
            $('#assessment-warning').modal('hide');
            $('#assessment-confirmation').modal('toggle');
            return;
          }
        } else if (
          this.$store.state.assessmentTypeKey == this.constants.ASSESSMENT_TYPE_KEY.REHEARSAL
        ) {
        } else {
          $('#assessment-complete').modal('hide');
          $('#assessment-warning').modal('hide');
          if (this.versionConfig.feedbackRedirectUrl) {
            let feedbackRedirectUrl = this.versionConfig.feedbackRedirectUrl.includes('https://')
              ? this.versionConfig.feedbackRedirectUrl
              : 'https://' + this.versionConfig.feedbackRedirectUrl;
            window.onbeforeunload = undefined;
            window.location = feedbackRedirectUrl;
          } else {
            this.$router.push({ name: 'feedback' });
          }
        }
      },

      async exitToDashboard() {
        window.location.href = '/capsiminbox/student/dashboard';
      },

      showInboxPastDueEnforcedModal() {
        $('#past-due-modal-inbox-enforced').modal({ backdrop: 'static', keyboard: false });
      },
      showExamPastDueModal() {
        $('#past-due-modal').modal({ backdrop: 'static', keyboard: false });
      },
      showInboxPastDueModal() {
        $('#past-due-modal-inbox').modal({ backdrop: 'static', keyboard: false });
      },
      showManualExitModal() {
        $('#assessment-warning').modal({ backdrop: 'static', keyboard: false });
      },
      checkIfComplete() {
        if (this.assessmentPreviouslyCompleted) {
          $('#already-complete-modal-inbox').modal({ backdrop: 'static', keyboard: false });
        }
      },
      setThreadedEmailsOnReEntry: debounce(function () {
        let selectedAnswers = [];

        this.activeMessages.map((am) => {
          if (am.answer) selectedAnswers.push(am.answer[0].answerKey);
        });
        this.answeredEmails.map((e) => {
          if (e.answer) selectedAnswers.push(e.answer[0].answerKey);
        });

        //if you have answered emails at this point, we know you are reentering, and we want to remove the time delay from non-threaded emails
        if (this.answeredEmails.length > 0) {
          this.cleanEmails.forEach((e) => {
            if (e.timer > 0) {
              Vue.set(e, 'timer', null);
            }
          });
          this.activeMessages.forEach((m) => {
            if (m.timer > 0) {
              Vue.set(m, 'timer', null);
            }
          });
        }

        //this gets all the threaded emails/messages that have been delivered prior to re-entering and delivers them
        this.messagesFromThread.forEach((m) => {
          if (
            m.dependencies.length > 0 &&
            selectedAnswers.indexOf(m.dependencies[0].FK_answerKey) > -1
          ) {
            Vue.set(m, 'dependencies', []);
            Vue.set(m, 'timer', null);
          }
        });

        this.threadEmails.forEach((te) => {
          if (selectedAnswers.indexOf(te.dependencies[0].FK_answerKey) > -1) {
            Vue.set(te, 'dependencies', []);
            Vue.set(te, 'timer', null);
          }
        });
      }, 5000),
      updateOnlineStatus(event) {
        if (this.versionTemplateKey == 2) {
          this.onLine = event.type === 'online';
          this.showOffLineModal();
        }
      },
      showOffLineModal() {
        if (!this.onLine) $('#error-response-modal').modal({ backdrop: 'static', keyboard: false });
      },

      showWelcomeBackModal() {
        const allowReEntry = this.versionConfig.allowReEntryInbox || this.allowInboxSimReEntry;

        if (this.studentReEntered && allowReEntry) {
          $('#welcome-back-modal').modal({ backdrop: 'static', keyboard: false });
          clearInterval(this.timeinterval);
        }
      },
      exitWelcomebackModal(value) {
        this.isWelcomebackModalClosed = value;
        //Sending messsages asynchronously when user is closing the browser or refreshing the browser
        window.addEventListener(
          'pagehide',
          onUnload.bind(
            null,
            { actionKey: JSON.stringify(14) },
            '/capsiminbox/webapp/log-activity',
            this.$store.state.assessmentTypeKey,
            this.isWelcomebackModalClosed
          )
        );
        window.addEventListener(
          'unload',
          onUnload.bind(
            null,
            { actionKey: JSON.stringify(14) },
            '/capsiminbox/webapp/log-activity',
            this.$store.state.assessmentTypeKey,
            this.isWelcomebackModalClosed
          )
        );

        if (
          this.$store.state.assessmentTypeKey ==
          this.$store.getters.constants.ASSESSMENT_TYPE_KEY.WEBAPP
        ) {
          if (this.$store.state.versionTemplateKey != 2 && this.$store.state.studentReEntered)
            return this.$store
              .dispatch('START_SIM')
              .then(() => this.$store.dispatch('SET_PHASE_DEPENDANT_QUESTIONS'))
              .catch((err) => console.error(err));
        }
      },
      openSubmitModal() {
        $('#assessment-warning').modal('hide');
        $('#assessment-submit').modal({ backdrop: 'static', keyboard: false });
      },
    },
  };
</script>

<style lang="scss">
  .notification-box {
    position: absolute;
    top: 3px !important;
    right: 20px !important;
    box-shadow: 0 0 2px #424242 !important;
    width: auto;
    z-index: 9999;
    padding: 10px !important;
  }
  .close {
    opacity: 0.7 !important;
  }

  .slide-notification-enter {
    transform: translateX(300px) !important;
    opacity: 0;
  }
  .slide-notification-leave-to {
    transform: translateX(-200px) !important;
    opacity: 0;
  }

  .col-wrapper {
    background-color: #f1f2f7;

    > div:first-of-type {
      border-right: 1px solid #dadadc;
    }
    > div {
      border-right: 1px solid #dadadc;
    }
  }

  .attachment-image {
    box-sizing: border-box;
    display: block;
    margin: 0 auto;
    max-height: 75vh;
    max-width: 100%;
  }

  .modal-body-text {
    font-size: 18px;
    margin-bottom: 18px;
  }
</style>
